import { createCustomTheme } from "@intelligems/ig-theme";

export const theme = createCustomTheme();

export const Theme = typeof theme;
